import React, { useEffect, useState } from 'react';
import Loading from '../atoms/Loading';
import { useSelector, useDispatch } from 'react-redux';
import { saveSelectedPlanOptions, getSelectedPlanOptionsState, savePlanOptions, getPlanOptionsState, getPlanDetailState } from '../../utils/localStorage';
import { sessionKey } from '../../modules/app';
import { BASENAME } from '../../constants';
import {
  makeAdditionalParamsPlanDetail,
  makeQueryStringsWithDuplicatedSessionKey,
} from '../../utils/queryParams';
import ModalPlanOptionDetail from '../modal/ModalPlanOptionDetail';
import PlanOptionMenu from '../molecules/PlanOptionMenu';
import PlanOptionPriceBlock from '../molecules/PlanOptionPriceBlock';
import { usePrice } from '../../utils/price';

const selector = (state) => ({
  flight: state.flight,
  hotel: state.hotel,
  planDetail: state.planDetail,
  planOptions: state.planOptions,
});

const PlanOption = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [displayGoods, setDisplayGoods] = useState(null);
  const [displayItineraryIndex, setDisplayItineraryIndex] = useState(null);
  const [displayPeopleCounts, setDisplayPeopleCounts] = useState(null);
  const [selectedPlanOptions, setSelectedPlanOptions] = useState([]); //直近で選択したPlanOptionsを保存する
  const [planOptionsState, setPlanOptionsState] = useState(null);
  const [enableConfirmButton, setEnableConfirmButton] = useState(false);
  const [itineraryArrayLength, setItineraryArrayLength] = useState(0);
  const [planOptionTotalAmount, setPlanOptionTotalAmount] = useState(0);

  const { flight: flightState, planOptions } = useSelector(selector);
  const { planOptions: lands } = planOptions || {};
  const { hotel: landHotel, land: landDetail } = lands || {};
  const { flightsInput, selectedOutboundFlight, selectedInboundFlight } = flightState;
  const { people } = flightsInput;

  // localStorageから選択済みプラン情報を取得
  const planDetailFromStorage = getPlanDetailState(sessionKey);
  const { plans: storagePlans } = planDetailFromStorage;
  const selectedPlans = storagePlans && storagePlans.map((plan) => plan.plan);

  const { planCD: planId, roomTypeCD: roomTypeId } = landHotel || {};
  const { selectedOutboundDate } = flightState;
  const { totalPrice: totalAmountWithoutPlanOption } = usePrice(people, selectedOutboundFlight, selectedInboundFlight, selectedPlans, selectedOutboundDate);
  const planDetailParams = makeAdditionalParamsPlanDetail(planId, roomTypeId);

  const handleBackLink = () => {
    const searchConfirm = makeQueryStringsWithDuplicatedSessionKey(planDetailParams);
    const planDetailLink = `${BASENAME}/plan_detail?${searchConfirm}`;
    window.open(planDetailLink, '_self');
  };

  // 着地の差額を更新する
  const updatePlanOptionTotalAmount = (newSelectedPlanOptions) => {
    // planOptionTotalAmountを更新
    let planOptionTotalAmount = 0;
    newSelectedPlanOptions.forEach((option) => {
      const { peopleCounts } = option;
      const { chargesList } = peopleCounts;
      chargesList.map((charge) => {
        const { kind, priceDiff } = charge;
        const peopleNum = peopleCounts[kind];
        planOptionTotalAmount += priceDiff * peopleNum;
      });
    });

    setPlanOptionTotalAmount(planOptionTotalAmount);
  }
   // localStorageに既に着地情報が保存されていれば、そちらを使う

  // 着地情報が変わったら、着地の行程数を取得する
  useEffect(() => {
    if (landDetail) {
      setItineraryArrayLength(landDetail.itinerary.length);
    }
  }, [landDetail]);

  // 初回表示時のみ、ローカルストレージに保存された値を読み込む
  useEffect(() => {
    const storagePlanOptions = getSelectedPlanOptionsState(sessionKey);
    const planOptionsState = getPlanOptionsState(sessionKey);
    setPlanOptionsState(planOptionsState);
    if(storagePlanOptions.length > 0) {
      setSelectedPlanOptions(storagePlanOptions);
      updatePlanOptionTotalAmount(storagePlanOptions);
      setEnableConfirmButton(true);
    }
  }, []);

  // 着地情報をセットする（ローカルストレージに保存された値があればそちらを使う）
  const displayLandDetail = (planOptionsState && planOptionsState.itinerary) ? planOptionsState : landDetail;

  // 着地情報を読み込むまではローディング表示
  if (Array.isArray(lands) && lands.length === 0) {
    return <Loading show progressRate={50} />;
  }

  // 選択ボタンクリック時に着地詳細モーダルを表示する
  const handleSelectButtonClick = (goods, itineraryIndex) => {
    
    // selectedPlanOptionsから既存の選択されたgoodsを検索
    if (selectedPlanOptions) {
      const existingOption = selectedPlanOptions.find(
        option => option.itineraryIndex === itineraryIndex && option.goods.goodsCode === goods.goodsCode
      );
      
      if (existingOption && existingOption.peopleCounts) {
        setDisplayPeopleCounts(existingOption.peopleCounts);
      }else{
        setDisplayPeopleCounts(null);
      }
    }
    
    setDisplayGoods(goods);
    setDisplayItineraryIndex(itineraryIndex);
    setIsModalOpen(true);
  };

  // モーダルクローズボタン押下
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  // モーダル内での選択ボタンクリック時に選択したGoodsを保存する
  const handleSelectGoods = (goods, itineraryIndex, peopleCounts) => {

    const addSelectedPlanOptions = {itineraryIndex: itineraryIndex, goods: goods, peopleCounts: peopleCounts}; //直近で選択した着地素材
    const currentSelectedPlanOptions = selectedPlanOptions || [];
    
    // itineraryIndexが一致する要素があるかチェック
    const existingIndex = currentSelectedPlanOptions.findIndex(
      option => option.itineraryIndex === itineraryIndex
    );
    
    let newSelectedPlanOptions;
    if (existingIndex !== -1) {
      // 既存の要素を差し替え
      newSelectedPlanOptions = [...currentSelectedPlanOptions];
      newSelectedPlanOptions[existingIndex] = addSelectedPlanOptions;
    } else {
      // 新しい要素を追加
      newSelectedPlanOptions = [...currentSelectedPlanOptions, addSelectedPlanOptions];
    }
    
    setSelectedPlanOptions(newSelectedPlanOptions);

    // planOptionTotalAmountを更新
    updatePlanOptionTotalAmount(newSelectedPlanOptions);

    setEnableConfirmButton(itineraryArrayLength === newSelectedPlanOptions.length);
    saveSelectedPlanOptions(sessionKey, newSelectedPlanOptions);
    setIsModalOpen(false);
  };

  // 内容確認画面へ遷移するボタンクリック
  const handleClickConfirmButton = () => {

    // 着地の行程数と選択された行程数が一致しない場合は、ボタンを無効化
    if(selectedPlanOptions.length !== itineraryArrayLength){
      console.error('行程数が一致しません');
      return;
    }

    // 着地情報をlocalStorageに保存
    savePlanOptions(sessionKey, displayLandDetail);

    // 内容確認画面へ遷移
    const searchConfirm = makeQueryStringsWithDuplicatedSessionKey(planDetailParams);
    const entryConfirmLink = `${BASENAME}/entry_confirm?${searchConfirm}`;
    window.open(entryConfirmLink, '_self');
  };

  return (
    <React.Fragment>
      <div className="pagePlanOption">
        <div className="lineTitleGray">
          <h1 className="lineTitle lg">タビサキMenu選択</h1>
        </div>
        <div className="pagePlanOptionBody">
          <p className="pagePlanOptionText">
            当プランでご利用いただくタビサキMenuは以下の通りです。<br />
            ご希望のタビサキMenuを「選択する」ボタンで選択し、利用日・参加人員ごとの利用人数を選択し「確定する」ボタンを押してください。
          </p>
          <div className="pagePlanOptionNote">
            <p>
              ※参加人員ごとにメニューの選択はできません。同一グループ同一メニューを選択してください。<br />
              ※メニュー・利用日が指定されている場合、参加人員ごとの利用人数を登録してください。<br />
              ※メニューごとに必ず1つご選択ください。<br />
              ※在庫状況は特筆のない限り、出発日の在庫状況となります。<br />
              　「選択する」ボタンからご希望の利用日をお選びください。<br />
              　ただし、利用日が指定されているものもございます。<br />
              ※空き状況によっては、利用可能なプランがない場合があります。その際は他の日程やプランをご検討ください。
            </p>
          </div>
        </div>

        {displayLandDetail && displayLandDetail.itinerary && Array.isArray(displayLandDetail.itinerary) && (
          <React.Fragment>
            {displayLandDetail.itinerary.length > 0 && displayLandDetail.itinerary.map((itinerary, index) => {
              const selectedOption = selectedPlanOptions ? selectedPlanOptions.find(option => option.itineraryIndex === index) : null;
              const selectedGoods = selectedOption ? selectedOption.goods : null;
              return (
                <PlanOptionMenu
                  key={`itinerary-${index}`}
                  handleSelectButtonClick={handleSelectButtonClick}
                  itinerary={itinerary}
                  itineraryIndex={index}
                  selectedOutboundDate={selectedOutboundDate}
                  selectedGoods={selectedGoods}
                />
              );
            })}
          </React.Fragment>
        )}

        {displayLandDetail && (
          <PlanOptionPriceBlock 
            handleClickConfirmButton={handleClickConfirmButton}
            enableConfirmButton={enableConfirmButton}
            planOptionTotalAmount={planOptionTotalAmount}
            totalAmountWithoutPlanOption={totalAmountWithoutPlanOption}
          />
        )}

        <div className="pagePlanInformationBlock">
          <p className="title">ご案内・ご注意</p>
          <p>・タビサキMenuの差額料金は、基本代金からの差額となります。<br />
          　※基本代金とは・・・<br />
          　選択した航空便＋宿泊代金＋メニュー１～３のそれぞれ最上段タビサキMenu料金の合計</p>
          <p>・お申込み完了後、タビサキMenuの変更はできませんのでご注意ください。</p>
        </div>


        <div className="pagePlanOptionBackLink">
          <span onClick={handleBackLink} className="pagePlanOptionBackLinkText">前のページに戻る</span>
        </div>
      </div>

      <ModalPlanOptionDetail
        title="プラン詳細"
        open={isModalOpen}
        onClose={handleModalClose}
        goods={displayGoods}
        itineraryIndex={displayItineraryIndex}
        onSelectGoods={handleSelectGoods}
        people={people}
        selectedPeopleCounts={displayPeopleCounts}
      />
      </React.Fragment>
  );
};

export default PlanOption;